// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import { FormGroup } from 'react-bootstrap';
import styled from 'styled-components';

const StyleFormGroup = styled(FormGroup)`
    display: ${props => props.display || 'flex'};
    align-items: center;
    margin-bottom: 20px;
    width: ${props => (props.isMobileView ? '100%' : '80%')};
    
    label {
        width: 10%
        margin-right: 30px;
        display: ${props => (props.isMobileView ? 'none' : 'inline')};
    }
    
    textarea {
      flex: 1;      
    }
    
    
    button {
        margin-left: 30px;
    }
`;

const ActivityFormFieldWrapper = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  children,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  label,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  isMobileView,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  display,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  style,
}) => (
  <StyleFormGroup
    controlId={label}
    isMobileView={isMobileView}
    display={display}
    style={style}
  >
    {children}
  </StyleFormGroup>
);

export default ActivityFormFieldWrapper;
